<template>
	<div
		class="configurator-step__inner configurator-step__inner--light-blue mt-m mb-s"
		:class="{'configurator-step__inner--valid' : customSizeValid}">
		<h4 class="mb-s">Kies uw eindformaat</h4>
		<div class="grid grid--gutters">

			<div class="cell">
				<label class="input-label">Breedte:</label>
				<input
					class="input-field input-field--border"
					type="number"
					v-model.number="customWidth"
					@input="validateCustomSize"
					placeholder="Breedte"
					min="0">
			</div>

			<div class="cell">
				<label class="input-label">Hoogte:</label>
				<input
					class="input-field input-field--border"
					type="number"
					v-model.number="customHeight"
					@input="validateCustomSize"
					placeholder="Hoogte"
					min="0">
			</div>

			<div class="cell">
				<div class="custom-sizes-unit">
					<label class="input-label">Eenheid:</label>
					<div class="dropdown-container">
						<select
							v-model="customUnitSize"
							class="input-field input-field--border"
							@change="validateCustomSize">
							<option
								v-for="(unit, index) in unitSizes"
								:key="index"
								v-text="unit.name"
								:selected="unit === customUnitSize"
								:value="unit"/>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div
			class="custom-size-message mt-s"
			v-if="!customSizeValid">
			<p>Kies een breedte tussen
				{{ calculatedAmount(trimmedLimits.minWidthInMm) }} en
				{{ calculatedAmount(trimmedLimits.maxWidthInMm) }} {{ customUnitSize.name }} en een hoogte tussen
				{{ calculatedAmount(trimmedLimits.minHeightInMm) }} en
				{{ calculatedAmount(trimmedLimits.maxHeightInMm) }} {{ customUnitSize.name }}.
			</p>
		</div>
		<div
			class="custom-size-message mt-s"
			v-else>
			<p>
				<span v-html="getSelectedFormatDescription"/>
			</p>
		</div>
	</div>
</template>

<script>
import step from "@/components/step/step";

export default {
	name: "FormatCustom",
	components: {step},
	data () {
		return {
			customWidth: 0,
			customHeight: 0,
			customUnitSize: null,
			unitSizes: [
				{name: "mm", multiplier: 1},
				{name: "cm", multiplier: 10},
				{name: "m", multiplier: 1000}
			]
		};
	},
	computed: {
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		trimmedLimits () {
			// The specification sizes include bleed, the entered size is the end size without bleed
			const f = this.selectedFormat;
			const axisBleed = (f.bleed || 0) * 2;

			return {
				minWidthInMm: f.minWidthInMm - axisBleed,
				maxWidthInMm: f.maxWidthInMm - axisBleed,
				minHeightInMm: f.minHeightInMm - axisBleed,
				maxHeightInMm: f.maxHeightInMm - axisBleed
			};
		},
		customWidthInMm () {
			return this.customWidth * this.customUnitSize.multiplier;
		},
		customHeightInMm () {
			return this.customHeight * this.customUnitSize.multiplier;
		},
		getCustomSize () {
			return this.$store.getters.getCustomSize;
		},
		customSizeValid () {
			return this.$store.getters.getCustomSizeValid;
		},
		getSelectedFormatDescription () {
			return this.$store.getters.getSelectedFormatDescription;
		}
	},
	methods: {
		calculatedAmount (input) {
			return input / this.customUnitSize.multiplier;
		},
		setFirstActive () {
			this.customUnitSize = this.unitSizes[1];
		},
		setCustomSize (data) {
			this.$store.commit("SET_CUSTOM_SIZE", data);
		},
		validateCustomSize () {
			const f = this.trimmedLimits;

			const portraitCondition = this.customHeightInMm < f.minHeightInMm
				|| this.customHeightInMm > f.maxHeightInMm
				|| this.customWidthInMm < f.minWidthInMm
				|| this.customWidthInMm > f.maxWidthInMm;

			const landscapeCondition = this.customWidthInMm < f.minHeightInMm
				|| this.customWidthInMm > f.maxHeightInMm
				|| this.customHeightInMm < f.minWidthInMm
				|| this.customHeightInMm > f.maxWidthInMm;

			const squareCondition = this.customWidthInMm < Math.max(f.minHeightInMm, f.minWidthInMm)
				|| this.customWidthInMm > Math.min(f.maxHeightInMm, f.maxWidthInMm);

			const setCustomFormatInvalid = () => {
				this.$store.commit("SET_CUSTOM_SIZE_VALID", false);
				this.$store.commit("SET_STEP_INVALID");
				this.setCustomSize({width: null, height: null});
			};

			const setCustomFormatValid = () => {
				this.$store.commit("SET_CUSTOM_SIZE_VALID", true);
				this.$store.commit("SET_STEP_VALID");
				this.setCustomSize({
					height: this.customHeightInMm,
					width: this.customWidthInMm
				});
			};

			if (this.customWidth && this.customHeight) {
				if (this.customWidthInMm < this.customHeightInMm) {
					if (portraitCondition) {
						setCustomFormatInvalid();

						if (landscapeCondition) {
							setCustomFormatInvalid();
						} else {
							setCustomFormatValid();
						}
					} else {
						setCustomFormatValid();
					}
				} else if (this.customWidthInMm > this.customHeightInMm) {
					if (landscapeCondition) {
						setCustomFormatInvalid();

						if (portraitCondition) {
							setCustomFormatInvalid();
						} else {
							setCustomFormatValid();
						}
					} else {
						setCustomFormatValid();
					}
				} else if (this.customWidthInMm === this.customHeightInMm) {
					if (squareCondition) {
						setCustomFormatInvalid();
					} else {
						setCustomFormatValid();
					}
				}
			} else {
				setCustomFormatInvalid();
			}
		},
		getSetCustomSize () {
			if (this.getCustomSize != null) {
				this.customWidth = this.calculatedAmount(this.getCustomSize.width);
				this.customHeight = this.calculatedAmount(this.getCustomSize.height);
			}
		}
	},
	created () {
		this.setFirstActive();
	},
	mounted () {
		this.getSetCustomSize();
		this.validateCustomSize();
	},
	beforeDestroy () {
		if (this.$store.getters.getCurrentStep.data.name !== "uploader" && !this.$store.getters.isCustomSize) {
			this.setCustomSize({width: null, height: null});
		}

		this.$store.commit("SET_STEP_VALID");
	}
};
</script>



// WEBPACK FOOTER //
// src/components/optional/format-custom.vue